import { useEffect, useState } from 'preact/hooks';

export default ({ fetchFiltersUrl }) => {
	const [filters, setFilters] = useState(null);

	useEffect(() => {
		if (!fetchFiltersUrl) {
			return;
		}

		fetch(fetchFiltersUrl).then(result => result.json()).then(filters => {
			setFilters(filters);
		});
	}, []);

	return filters;
};